// extracted by mini-css-extract-plugin
module.exports = {"icon":"LogoLoader_icon__xMV4G","rotate":"LogoLoader_rotate__H_i1e"};